import qs from "qs";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import { useGetReferredUser } from "../../../queryHooks";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import CS from "../../../services/commonService";
import Icon from "../../icons/index";
import ReactTooltip from "react-tooltip";
import { URL } from "../../../constants/URL";
import { useStore } from "../../../zustand/store";
import { modules } from "../../../constants/Modules";
import RenderUser from "../../common/User";

//	Pre-defined values
const columnKey = "users";
//	Component starts
const ReferredUsers = ({ userId, tabChangeCounter, tabKey }) => {
	const navigate = useNavigate();
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	//	State values
	const [tableData, setTableData] = useState([]);
	const [pageNow, setPageNow] = useState(
		lastPageData?.[`${modules.REFERRED_USERS}${userId}`]?.page || 1
	);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[`${modules.REFERRED_USERS}${userId}`]?.items_per_page || 10
	);
	const [payload, setPayload] = useState(
		lastPageData?.[`${modules.REFERRED_USERS}${userId}`] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { created_at: "DESC" },
		}
	);

	const { data: referredUsersdata, isLoading } = useGetReferredUser({
		userId,
		queryParams: qs.stringify(payload),
	});

	useEffect(() => {
		if (referredUsersdata && referredUsersdata.status === "success") {
			let respData = referredUsersdata.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [referredUsersdata]);

	useEffect(() => {
		setPageNow(1);
		setItemsPerPage(10);
		setPayload({
			pagination: true,
			items_per_page: 10,
			page: 1,
		});
	}, [userId]);

	useEffect(() => {
		setPayload({
			...payload,
		});
	}, [tabChangeCounter]);

	const setFilters = () => {
		setLastPageData({
			[`tabKey${userId}`]: tabKey,
			[`${modules.REFERRED_USERS}${userId}`]: payload,
		});
	};

	const columns = [
		{
			label: "Joined Date",
			type: "date",
			sort: true,
			path: "created_at",
			alias: "created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item.created_at),
		},
		{
			label: "Username",
			type: "string",
			sort: true,
			path: "username",
			alias: "username",
		},
		{
			label: "Name",
			type: "string",
			path: "name",
			alias: "first_name",
			sort: true,
			content: (item) => (
				<Link
					to={`${URL.onboarderedUsers}/${item?.user_id}`}
					onClick={setFilters}
				>
					<RenderUser
						profileImageUrl={item?.profile_image_url}
						firstName={item?.first_name}
						lastName={item?.last_name}
					/>
				</Link>
			),
		},
		{
			label: "Email",
			type: "string",
			sort: true,
			path: "email",
			alias: "email",
			content: (item) => (
				<div className="email-col d-flex align-items-center">
					<span>{item.email}</span>
				</div>
			),
		},
		{
			label: "Phone No",
			type: "string",
			path: "mobile",
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="show"
						data-tip
						data-for="show"
						onClick={() => {
							setFilters();
							navigate(`${URL.onboarderedUsers}/${item?.user_id}`);
						}}
					/>
					<ReactTooltip id="show" place="top" effect="solid">
						Show
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												searchValue={
													lastPageData?.[`${modules.REFERRED_USERS}${userId}`]
														?.search?.username
												}
												search={(value) => {
													setPageNow(1);
													setPayload({
														...payload,
														search: {
															username:
																!value && value === "" ? undefined : value,
															first_name:
																!value && value === "" ? undefined : value,
															last_name:
																!value && value === "" ? undefined : value,
															email: !value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
								</div>
							</div>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setPayload({
										...payload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setPayload({ ...payload, page });
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setPayload({
										...payload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = CS.filterData(payload.filter, obj);
										setPageNow(1);
										setPayload({
											...payload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setPayload({
											...payload,
											filter: {
												...payload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setPayload({
										...payload,
										filter_date: dates && {
											...payload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
								tabChangeCounter={tabChangeCounter}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ReferredUsers;
